<app-ui-sidebar
  [menuSections]="menuSections"
  [activePath]="activePath"
  [collapsed]="isCollapsed"
  logoText="PA"
  [companyName]="companyName"
  appName="SupplySync ERP"
  (navigate)="onNavigate($event)">
</app-ui-sidebar>
